export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/GPshowMoreOptions.png?9588041dcc44d31cb0708187a502a925";